import axios from '../utils/axios';

export default function addDiversityPlan(adminId, data) {
    return axios.post('/admin/' + adminId + '/add-diversity-plan', data);
}